import { render, staticRenderFns } from "./ShowTypesMaintenance.vue?vue&type=template&id=116726d8"
import script from "./ShowTypesMaintenance.vue?vue&type=script&lang=ts"
export * from "./ShowTypesMaintenance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports